/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
function checkLazySize(){
  lazySizes.autoSizer.checkElems();
}
setTimeout(checkLazySize, 1000);
setTimeout(checkLazySize, 2000);
setTimeout(checkLazySize, 4000);
 
ScrollReveal().reveal('.product-top', { afterReveal: checkLazySize });